export const GOOGLE_SCRIPT_SRC =
  'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
export const GOOGLE_SELECTOR_DIV_NAME = 'google_translate_element';
export const GOOGLE_SKIP_SELECTION_DIV_NAME = 'skiptranslate';
